



















import { Mobile } from "@/mixins/mobile";
import { LineItem } from "@/models/order/order";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

/** FUPOF-191: saving a draft happens on checkout only — the cart just continues. */
@Component({ components: { SurchargeBanner } })
export default class CartFooter extends mixins(Mobile) {
  @Prop() items!: LineItem[];
  @Prop({ default: false }) hasQtyWarning!: boolean;
  /** Unresolved NetSuite drift: the quote may not be checked out
   * until the DriftResolver's changes are applied. */
  @Prop({ default: false }) locked!: boolean;

  protected handleContinueButtonClick(): void {
    if (this.locked) return;
    this.$router.push("/checkout");
  }
}
